<template>
    <div :class="['free-menbership-content', size]">
        <div class="cards">
            <div class="crown"></div>
            <div class="best-rights">
                <div class="title">
                    <span class="high-light"><span class="num">4</span>大黄金权益</span>
                    <span class="dot">·</span>
                    <span class="text">让案源获取更简单</span>
                </div>
                <div class="content">
                    <div
                        v-for="(item, index) in bestRightsList"
                        :key="index"
                        class="best-right-item"
                        :style="{backgroundImage: `url(${item.image})`}"
                    >
                        <div class="best-right-item-top">
                            <div class="image"><img :src="item.icon"/></div>
                            <div class="title">{{ item.title }}</div>
                        </div>
                        <div class="best-right-item-bottom">
                            <div class="subTitle">{{ item.subTitle }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="good-rights">
                <div class="title">
                    <span class="high-light"><span class="num">6</span>大超值权益</span>
                    <span class="dot">·</span>
                    <span class="text">助力律师经营</span>
                </div>
                <div class="content">
                    <div
                        v-for="(item, index) in goodRightsList"
                        :key="index"
                        class="good-right-item"
                    >
                        <div class="good-right-item-top">
                            <div class="image"><img :src="item.image"/></div>
                            <div class="title">{{ item.title }}</div>
                        </div>
                        <div class="good-right-item-bottom">
                            <div class="subTitle">{{ item.subTitle }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import 'veui-theme-dls/typography.less';
/**
 * @desc 免费体验会员引导内容
 * @author <xingminghua@baidu.com>
 */

const BEST_RIGHTS_LIST = [
    {
        image: 'https://lvlin-fe-saas.cdn.bcebos.com/lawInfo/01.png',
        title: '搜索首位曝光',
        subTitle: '快速获取百度首页展现个人专属名片卡的权益',
        icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/law-service/rights/search-first-vip.png'
    },
    {
        image: 'https://lvlin-base.cdn.bcebos.com/fe-saas/component/free-membership/clue-card.png',
        title: '客户线索认领',
        subTitle: '一键领取平台精选优质线索，让案源获取更简单',
        icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/law-service/rights/get-clue-vip.png'
    },
    {
        image: 'https://lvlin-fe-saas.cdn.bcebos.com/lawInfo/03.png',
        title: '公开咨询抢答',
        subTitle: '海量网友法律问答等你答，获取与客户零距离沟通的机会',
        icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/law-service/rights/consult-race-vip.png'
    },
    {
        image: 'https://lvlin-fe-saas.cdn.bcebos.com/lawInfo/04.png',
        title: '法律问答署名',
        subTitle: '获得平台优质法律内容署名权，简单高效获取搜索流量',
        icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/law-service/rights/law-sign-vip.png'
    }
];

const GOOD_RIGHTS_LIST = [
    {
        image: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/law-service/rights/yanxuan-vip.png',
        title: '严选律师标签',
        subTitle: '法行宝权威背书，让你在一众律师中脱颖而出'
    },
    {
        image: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/law-service/rights/consult-pay-vip.png',
        title: '付费电话咨询',
        subTitle: '接收付费电话咨询，高效知识变现'
    },
    {
        image: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/law-service/rights/prior-picture-vip.png',
        title: '图文优先展示',
        subTitle: '律师生产的所有图文将会在百度内获得优先展示'
    },
    {
        image: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/law-service/rights/search-law-vip.png',
        title: '法规检索工具',
        subTitle: '国家法律法规数据快速检索'
    },
    {
        image: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/law-service/rights/good-domain-vip.png',
        title: '擅长领域标签',
        subTitle: '匹配相关领域流量及客户资源，精准触达用户'
    },
    {
        image: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/law-service/rights/search-case-vip.png',
        title: '案例检索工具',
        subTitle: '全网案例收录，提供完整全面的案例检索能力'
    }
];

export default {
    props: {
        // 大小
        size: {
            type: String,
            default: 'normal'
        }
    },
    data() {
        return {
            bestRightsList: BEST_RIGHTS_LIST,
            goodRightsList: GOOD_RIGHTS_LIST
        };
    }
};
</script>
<style lang="less" scoped>
.free-menbership-content {
    width: 100%;

    .cards {
        padding: 30px 24px 30px;
        background: linear-gradient(137deg, #fff8ec 7.02%, #fed 80.73%);
        margin-bottom: 40px;
        border: 1px solid rgba(251, 229, 187, .3);
        border-radius: 8px;
        position: relative;
        overflow: hidden;

        .crown {
            position: absolute;
            right: 0;
            top: -19px;
            width: 439px;
            height: 224px;
            background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/component/free-membership/gold-crown2.png") no-repeat center center / 100% 100%;
        }

        .title {
            .high-light {
                font-family: PingFangSC-Semibold;
                font-size: 24px;
                color: #1e1f24;
                line-height: 30px;
                font-weight: 600;
                box-sizing: border-box;
                position: relative;
                z-index: 1;

                &::after {
                    content: "";
                    width: 100%;
                    height: 8px;
                    background: linear-gradient(116deg, #ffd3b4 13.2%, #ffe6ca 100%);
                    position: absolute;
                    left: 0;
                    z-index: -1;
                    bottom: 0;
                }

                .num {
                    font-family: "Baidu Number";
                    position: relative;
                    top: 2px;
                    font-size: 30px;
                    line-height: 30px;
                    font-weight: 500;
                }
            }

            .dot {
                font-family: PingFangSC-Semibold;
                font-size: 24px;
                color: #1e1f24;
                line-height: 30px;
                font-weight: 600;
                margin: 0 8px;
            }

            .text {
                font-family: PingFang SC;
                font-size: 16px;
                color: #1e1f24;
                line-height: 20px;
                font-weight: 400;
                position: relative;
                top: -2px;
            }
        }

        .content {
            display: flex;
            align-content: center;
            justify-content: flex-start;
            width: 100%;
            margin-top: 25px;
        }
    }

    .best-rights {
        margin-bottom: 30px;

        .content {
            position: relative;
            z-index: 2;

            .best-right-item {
                width: calc(((100% - 48px) / 4));
                height: 331px;
                border: 1px solid rgba(255, 116, 0, .11);
                border-radius: 8px;
                background-repeat: no-repeat;
                background-size: 100% 331px;
                background-position: center;
                overflow: hidden;
                padding: 16px;

                & + .best-right-item {
                    margin-left: 16px;
                }

                &-top {
                    display: flex;
                    align-items: center;

                    .image {
                        flex: 0 0 auto;
                        width: 36px;
                        height: 36px;
                        border-radius: 50%;
                        overflow: hidden;

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }

                    .title {
                        font-family: PingFangSC-Medium;
                        font-size: 16px;
                        color: #1e1f24;
                        font-weight: 500;
                        line-height: 16px;
                        margin-left: 10px;
                    }
                }

                &-bottom {
                    .subTitle {
                        margin-top: 6px;
                        font-family: PingFangSC-Regular;
                        font-size: 14px;
                        color: #848691;
                        line-height: 22px;
                        font-weight: 400;
                    }
                }
            }
        }
    }

    .good-rights {
        .content {
            flex-wrap: wrap;
            width: auto;
            margin-right: -16px;
            margin-bottom: -16px;

            .good-right-item {
                width: calc(((100% - 48px) / 3));
                height: 104px;
                background: #fff;
                border: 1px solid rgba(255, 116, 0, .18);
                border-radius: 8px;
                padding: 18px 14px 18px 18px;
                margin-right: 16px;
                margin-bottom: 16px;
                box-sizing: border-box;

                &-top {
                    display: flex;
                    align-items: center;

                    .image {
                        flex: 0 0 auto;
                        width: 36px;
                        height: 36px;
                        border-radius: 50%;
                        overflow: hidden;

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }

                    .title {
                        font-family: PingFangSC-Medium;
                        font-size: 16px;
                        color: #1e1f24;
                        line-height: 1;
                        font-weight: 500;
                        margin-left: 10px;
                    }
                }

                &-bottom {
                    .subTitle {
                        margin-top: 8px;
                        font-family: PingFangSC-Regular;
                        font-size: 14px;
                        color: #848691;
                        letter-spacing: 0;
                        line-height: 22px;
                        font-weight: 400;
                    }
                }
            }
        }
    }
    // small size
    &.small {
        .cards {
            padding: 22px 18px 22px;
            border-radius: 6px;

            .crown {
                width: 308px;
                height: 170px;
                top: -5px;
            }

            &.cards {
                margin-bottom: 14px;
            }

            .title {
                font-size: 16px;

                .high-light {
                    font-size: 24px;
                }
            }

            .content {
                margin-top: 20px;
            }
        }

        .best-rights {
            .content {
                .best-right-item {
                    width: calc(((100% - 48px) / 4));
                    height: 247px;
                    border-radius: 6px;
                    padding: 10px;
                    background-size: 100% 247px;

                    & + .best-right-item {
                        margin-left: 16px;
                    }

                    .image {
                        width: 30px;
                        height: 30px;
                    }

                    .title {
                        margin-left: 8px;
                        font-size: 14px;
                    }

                    .subTitle {
                        margin-top: 4px;
                        font-size: 12px;
                        line-height: 16px;
                    }
                }
            }
        }

        .good-rights {
            .content {
                margin-right: -12px;
                margin-bottom: -12px;

                .good-right-item {
                    width: calc(((100% - 36px) / 3));
                    height: 90px;
                    border-radius: 6px;
                    padding: 10px;
                    margin-right: 12px;
                    margin-bottom: 12px;

                    .image {
                        width: 30px;
                        height: 30px;
                    }

                    .title {
                        margin-left: 8px;
                        font-size: 14px;
                    }

                    .subTitle {
                        margin-top: 2px;
                        font-size: 12px;
                        line-height: 16px;
                    }

                    &-top {
                        margin-bottom: 6px;
                    }
                }
            }
        }
    }
}
</style>
